"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const redux_1 = require("redux");
const setting_1 = tslib_1.__importDefault(require("./reducers/setting"));
const react_router_redux_1 = require("react-router-redux");
const main_step_1 = tslib_1.__importDefault(require("./reducers/main-step"));
const main_step_2 = tslib_1.__importDefault(require("./reducers/main-step"));
const main_step_3 = tslib_1.__importDefault(require("./reducers/main-step"));
const column_selection_1 = tslib_1.__importDefault(require("./reducers/column-selection"));
const column_selection_2 = tslib_1.__importDefault(require("./reducers/column-selection"));
const column_selection_3 = tslib_1.__importDefault(require("./reducers/column-selection"));
const handling_missing_values_1 = tslib_1.__importDefault(require("./reducers/handling-missing-values"));
const handling_missing_values_2 = tslib_1.__importDefault(require("./reducers/handling-missing-values"));
const handling_missing_values_3 = tslib_1.__importDefault(require("./reducers/handling-missing-values"));
const handling_missing_values_4 = tslib_1.__importDefault(require("./reducers/handling-missing-values"));
const csv_data_1 = tslib_1.__importDefault(require("./reducers/csv-data"));
const column_selection_4 = tslib_1.__importDefault(require("./reducers/column-selection"));
const column_selection_5 = tslib_1.__importDefault(require("./reducers/column-selection"));
const column_selection_6 = tslib_1.__importDefault(require("./reducers/column-selection"));
const final_data_1 = tslib_1.__importDefault(require("./reducers/final-data"));
const column_selection_7 = tslib_1.__importDefault(require("./reducers/column-selection"));
const column_selection_8 = tslib_1.__importDefault(require("./reducers/column-selection"));
const column_selection_9 = tslib_1.__importDefault(require("./reducers/column-selection"));
const column_selection_10 = tslib_1.__importDefault(require("./reducers/column-selection"));
const column_selection_11 = tslib_1.__importDefault(require("./reducers/column-selection"));
const column_selection_12 = tslib_1.__importDefault(require("./reducers/column-selection"));
const column_selection_13 = tslib_1.__importDefault(require("./reducers/column-selection"));
const reducers = redux_1.combineReducers({
    routing: react_router_redux_1.routerReducer,
    setting: setting_1.default,
    mainStep: main_step_1.default,
    ProjectInfo: main_step_2.default,
    ProjectInitiationData: main_step_3.default,
    columnSelectionS22: column_selection_1.default,
    columnSelectionS32: column_selection_2.default,
    nullValueColumns: column_selection_3.default,
    handlingMissingValues: handling_missing_values_1.default,
    outlierVisualizations: handling_missing_values_2.default,
    interpolationData: handling_missing_values_3.default,
    lagVariables: handling_missing_values_4.default,
    saveCSVDataS21: csv_data_1.default,
    featureSelections: column_selection_4.default,
    samplingMethod: column_selection_5.default,
    trainTestRatio: column_selection_6.default,
    finalData: final_data_1.default,
    binary_thresholding: column_selection_7.default,
    feature_mapping_data: column_selection_8.default,
    dataTransform: column_selection_9.default,
    finalUniqueColumns: column_selection_10.default,
    model_selection: column_selection_11.default,
    graph_path: column_selection_12.default,
    data_transform_rsa_ms: column_selection_13.default,
});
exports.default = reducers;
//# sourceMappingURL=reducer.js.map